<template>
  <v-container fluid>
    <v-progress-circular v-if="loading" size="20" indeterminate color="rgba(0, 0, 0, 0.87)" />
    <div v-else>
      <v-timeline v-if="historico.length" dense>
        <v-timeline-item v-for="(alteracao, i) in historico" :key="i" :color="getCorPorNota(alteracao.nota)" small>
          <v-card class="elevation-2">
            <v-card-title class="text-h5" :style="{ color: getCorPorNota(alteracao.nota) }">
              Nota {{ alteracao.nota }} :: {{ alteracao.descricao_status }}
            </v-card-title>
            <v-divider />
            <v-card-text>
              <div v-if="alteracao.observacao">
                {{ alteracao.observacao }}
                <v-divider class="mb-4 mt-4" />
              </div>
              Alteração feita por {{ alteracao.usuario_alteracao }} em
              {{ alteracao.data_hora_status | parseToDateTimeBR }}
            </v-card-text>
          </v-card>
        </v-timeline-item>
      </v-timeline>
    </div>
  </v-container>
</template>

<script>
  import IqBdgdService from '@/services/IqBdgdService';
  import iqBdgdMixins from './iqBdgdMixins';

  export default {
    name: 'StatusIndicadorIcpTimeline',
    mixins: [iqBdgdMixins],
    props: {
      indicador: {
        type: String,
        required: true
      },
      bdgdVersao: {
        type: Object,
        required: true
      }
    },
    data: () => ({
      loading: false,
      historico: []
    }),
    mounted() {
      this.getHistoricoStatusPorIndicador();
    },
    methods: {
      getHistoricoStatusPorIndicador() {
        this.loading = true;
        IqBdgdService.getHistoricoStatusPorIndicador(this.bdgdVersao.id, this.indicador)
          .then((response) => {
            this.historico = response.data;
          })
          .catch((err) => {
            console.log('Erro: ', err);
            this.$toast.error(`Erro ao buscar o histórico do status do indicador ${this.indicador}.`, '', {
              position: 'topRight'
            });
          })
          .finally(() => (this.loading = false));
      }
    }
  };
</script>
